(() => {
"use strict";
// Shared, independently testable Shopify cart payload adapter.
function isCartAdd(url,method,base){
 const target=new URL(url,base),origin=new URL(base);
 return String(method||'GET').toUpperCase()==='POST' && target.origin===origin.origin && /\/cart\/add(?:\.js)?\/?$/.test(target.pathname);
}
function put(root,tokens,value){
 let obj=root;
 for(let i=0;i<tokens.length;i++){
  const key=tokens[i];
  if(['__proto__','constructor','prototype'].includes(key))return;
  if(i===tokens.length-1){if(key===''){if(Array.isArray(obj))obj.push(value);}else obj[key]=value;return;}
  const next=tokens[i+1],array=next===''||/^\d+$/.test(next);
  if(/^\d+$/.test(next)&&Number(next)>250)throw new Error('Túl sok kosártétel.');
  if(!obj[key]||typeof obj[key]!=='object')obj[key]=array?[]:Object.create(null);
  obj=obj[key];
 }
}
function decodeBody(body){
 if(typeof body==='string'&&body.trim().startsWith('{'))return JSON.parse(body);
 if(body && typeof body==='object' && !(body instanceof URLSearchParams) && !(body instanceof FormData))return null;
 if(typeof body!=='string'&&!(body instanceof URLSearchParams)&&!(body instanceof FormData))return null;
 const entries=typeof body==='string'?new URLSearchParams(body):body;
 const result=Object.create(null);
 for(const [key,value] of entries){
  // Property labels may themselves contain brackets: keep their text intact.
  const property=key.match(/^(?:items\[(\d+)\]\[properties\]|properties)\[(.*)\]$/);
  const tokens=property ? (property[1]!==undefined?['items',property[1],'properties',property[2]]:['properties',property[2]]) : [key.split('[')[0],...[...key.matchAll(/\[([^\]]*)\]/g)].map(m=>m[1])];
  put(result,tokens,value);
 }
 return result;
}
function hasFile(value){
 if(typeof Blob!=='undefined'&&value instanceof Blob)return value.size>0;
 if(value&&typeof value==='object')return Object.values(value).some(hasFile);
 return false;
}
function buildAdd(payload,configs,uuid=()=>crypto.randomUUID()){
 if(!payload||typeof payload!=='object')return null;
 const multiple=Array.isArray(payload.items),original=multiple?payload.items:[payload];
 if(!Array.isArray(configs)||!configs.length)return null;
 const allVariants=[...new Set(configs.flatMap(c=>c.variants.map(String)))];
 const matches=item=>item&&allVariants.includes(String(item.id));
 if(!original.some(matches))return null;
 const originalGroups=new Set(original.filter(i=>i?.properties?._ae_extra==='1').map(i=>i.properties._ae_group));
 const items=[],groups=[];
 for(const item of original){
  if(!matches(item)||originalGroups.has(item.properties?._ae_group)){items.push(item);continue;}
  const quantity=Number(item.quantity??1);
  if(!Number.isInteger(quantity)||quantity<1)throw new Error('Az extra nem adható hozzá: érvénytelen darabszám.');
  if(item.selling_plan)throw new Error('Az extra előfizetéses termékhez még nem használható.');
  if(hasFile(item))throw new Error('A közvetlen fájlfeltöltéshez külön illesztés szükséges. A terméket nem tettük a kosárba.');
  const group=uuid();groups.push(group);
  const names=configs.map(c=>c.title).join(', ');
  const main={...item,quantity,properties:{...(item.properties||{}),Extra:names,_ae_group:group}};
  for(const key of ['items','sections','sections_url','attributes','form_type','utf8'])delete main[key];
  items.push(main);
  for(const config of configs)items.push({id:Number(config.variant),quantity,properties:{'Ehhez a termékhez':config.productTitle,_ae_group:group,_ae_extra:'1'}});
 }
 if(!groups.length)return null;
 const output={...payload,items};
 if(!multiple)for(const key of ['id','quantity','properties','selling_plan','parent_id','parent_line_key'])delete output[key];
 return {payload:output,multiple,groups};
}
function restoreResponse(response,plan){
 if(!plan||!Array.isArray(response?.items))return response;
 const items=response.items.filter(item=>!(item.properties?._ae_extra==='1'&&plan.groups.includes(item.properties?._ae_group)));
 if(plan.multiple)return {...response,items};
 const main=items.find(item=>plan.groups.includes(item.properties?._ae_group))||items[0];
 return main?{...main,...(response.sections?{sections:response.sections}:{})}:response;
}
/* Boost 6.2.0 transport adapter. Retains the existing Boost/Teeinblue UI flow. */
if(window.__ajandekExtraBoostLoaded)return;
window.__ajandekExtraBoostLoaded=true;
const widgets=new Map();
function message(text){for(const state of widgets.values())if(state.anchor.isConnected){const error=state.widget.querySelector('[data-ae-error]');if(error)error.textContent=text;}}
function selected(){
 const result=[];
 for(const state of widgets.values()){
  if(!state.anchor.isConnected || !state.widget.querySelector('[data-ae-checkbox]')?.checked)continue;
  result.push({variant:state.widget.dataset.variant,title:state.widget.dataset.title,productTitle:state.widget.dataset.productTitle,variants:JSON.parse(state.widget.dataset.variants)});
 }
 return result;
}
function configForForm(form){
 for(const state of widgets.values())if(state.anchor.isConnected&&state.widget.dataset.formId===form.id)return state;
 return null;
}
function refresh(){
 for(const anchor of document.querySelectorAll('[data-ae-anchor]')){
  const found=anchor.querySelectorAll?[...anchor.querySelectorAll('[data-ae-boost]')]:[anchor.querySelector('[data-ae-boost]')].filter(Boolean);
  for(const widget of found){
   if(!widgets.has(widget)){
    const checkbox=widget.querySelector('[data-ae-checkbox]');if(!checkbox)continue;
    const state={anchor,widget,hidden:[]};widgets.set(widget,state);checkbox.disabled=widget.dataset.available!=='true';
    checkbox.addEventListener('change',()=>{message('');for(const s of widgets.values())updatePayments(s);});
   }
  }
 }
 const artwork=document.querySelector('#tee-artwork-form');
 const anchors=new Set([...widgets.values()].map(s=>s.anchor));
 for(const anchor of anchors){
  if(!anchor.isConnected)continue;
  const first=[...widgets.values()].find(s=>s.anchor===anchor)?.widget;
  const list =
  anchor.querySelector?.('[data-ae-list]') ||
  first?.closest?.('[data-ae-list]') ||
  first;
  if(artwork&&list){const form=artwork.closest('form');const target=artwork.querySelector('.tee_bundle-bundle')||artwork.querySelector('#teeFormActions')||form?.querySelector('#teeAtcButton');if(target&&target.previousElementSibling!==list)target.insertAdjacentElement('beforebegin',list);}
  else if(list&&!anchor.contains(list)){anchor.append(list);}
 }
 for(const [widget,state] of widgets){if(!state.anchor.isConnected||!widget){widgets.delete(widget);continue;}updatePayments(state);}
}
function updatePayments(state){
 const form=document.getElementById(state.widget.dataset.formId);
 const checked=[...widgets.values()].some(s=>s.anchor.isConnected&&s.widget.dataset.formId===state.widget.dataset.formId&&s.widget.querySelector('[data-ae-checkbox]')?.checked);
 if(!checked){for(const [el,hidden] of state.hidden)el.hidden=hidden;state.hidden=[];return;}
 for(const el of form?.querySelectorAll('.shopify-payment-button')||[]){
  if(!state.hidden.some(([old])=>old===el))state.hidden.push([el,el.hidden]);el.hidden=true;
 }
}
const nativeFetch=window.fetch.bind(window);
window.fetch=async function(input,init){
 const config=selected();
 const url=typeof input==='string'||input instanceof URL?String(input):input.url;
 const method=init?.method || (input instanceof Request?input.method:'GET');
 if(!config.length || !isCartAdd(url,method,location.href))return nativeFetch(input,init);
 const effective=new Request(input instanceof Request?input:new URL(url,location.href),init);
 let plan;
 try{
  const type=effective.headers.get('Content-Type')||'';
  const body=type.includes('multipart/form-data')?await effective.clone().formData():await effective.clone().text();
  const payload=decodeBody(body);
  if(!payload)throw new Error('Nem támogatott kosárkérés. Az extra miatt nem indítottuk el a vásárlást.');
  plan=buildAdd(payload,config);
  if(!plan)return nativeFetch(input,init);
  const headers=new Headers(effective.headers);headers.set('Content-Type','application/json');headers.delete('Content-Length');
  const outgoing=new Request(effective,{headers,body:JSON.stringify(plan.payload)});
  const response=await nativeFetch(outgoing);
  if(!response.ok){message('Az extra vagy a termék nem került a kosárba. Ellenőrizd a kosarat, és próbáld újra.');return response;}
  const result=await response.clone().json(),normalized=restoreResponse(result,plan);
  const responseHeaders=new Headers(response.headers);responseHeaders.delete('Content-Length');
  const replacement=new Response(JSON.stringify(normalized),{status:response.status,statusText:response.statusText,headers:responseHeaders});
  // Preserve response metadata for callers that inspect it.
  for(const key of ['url','redirected','type'])Object.defineProperty(replacement,key,{value:response[key]});
  message('');return replacement;
 }catch(error){message(error.message||'A kosárba helyezés nem sikerült.');throw error;}
};
// Boost 6.2.0 uses jQuery $.post (XMLHttpRequest), while Teeinblue can use fetch.
const NativeXHR=window.XMLHttpRequest;
window.XMLHttpRequest=class ExtraXHR extends NativeXHR{
 open(method,url,...args){this.aeMethod=method;this.aeUrl=url;this.aeHeaders=[];this.aePlan=null;return super.open(method,url,...args);}
 setRequestHeader(name,value){
  if(this.readyState!==1)return super.setRequestHeader(name,value);
  const check=new Headers();check.append(name,value);this.aeHeaders.push([name,value]);
 }
 send(body){
  let outgoing=body;
  try{
   const config=selected();
   if(config.length&&isCartAdd(this.aeUrl,this.aeMethod,location.href)){
    const payload=decodeBody(body);
    if(!payload)throw new Error('Nem támogatott kosárkérés. Az extrával nem folytatható a vásárlás.');
    this.aePlan=buildAdd(payload,config);
    if(this.aePlan)outgoing=JSON.stringify(this.aePlan.payload);
   }
   for(const [name,value] of this.aeHeaders||[])if(!this.aePlan||name.toLowerCase()!=='content-type')super.setRequestHeader(name,value);
   if(this.aePlan)super.setRequestHeader('Content-Type','application/json');
   if(this.aePlan)this.addEventListener('load',()=>{if(this.status>=200&&this.status<300)message('');else message('A kosárba helyezés nem sikerült. Ellenőrizd a kosarat.');},{once:true});
   return super.send(outgoing);
  }catch(error){message(error.message||'A kosárba helyezés nem sikerült.');throw error;}
 }
 get responseText(){
  const raw=super.responseText;
  if(!this.aePlan||this.status<200||this.status>=300)return raw;
  try{return JSON.stringify(restoreResponse(JSON.parse(raw),this.aePlan));}catch{return raw;}
 }
 get response(){
  const raw=super.response;
  if(!this.aePlan||this.status<200||this.status>=300)return raw;
  if(this.responseType==='json')return restoreResponse(raw,this.aePlan);
  if(this.responseType===''||this.responseType==='text')return this.responseText;
  return raw;
 }
};
// Retain support for the Boost 'go to cart' setting, which performs a native submit.
document.addEventListener('submit',async event=>{
 const form=event.target,state=configForForm(form);
 const anyChecked=[...widgets.values()].some(s=>s.anchor.isConnected&&s.widget.dataset.formId===form.id&&s.widget.querySelector('[data-ae-checkbox]')?.checked);
 if(!state || !anyChecked || form.classList.contains('ajax-product-form'))return;
 event.preventDefault();event.stopImmediatePropagation();
 if(form.dataset.aeBusy==='true')return;
 form.dataset.aeBusy='true';
 const buttons=[...form.querySelectorAll('[type="submit"]')],previous=buttons.map(b=>b.disabled);buttons.forEach(b=>b.disabled=true);
 try{
  const root=window.Shopify?.routes?.root||'/';
  const response=await window.fetch(root+'cart/add.js',{method:'POST',body:new FormData(form)});
  const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'A kosárba helyezés nem sikerült.');
  location.assign(root+'cart');
 }catch(error){message(error.message);}finally{delete form.dataset.aeBusy;buttons.forEach((b,i)=>b.disabled=previous[i]);}
},true);
let scheduled=false;
function schedule(){if(scheduled)return;scheduled=true;queueMicrotask(()=>{scheduled=false;refresh();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('teeinblue-event-component-injected',schedule);
document.addEventListener('shopify:section:load',schedule);

})();
